/**
 * 跳转链接
 */
import { i18n } from '@/locales/i18n';
import { jumpRecharge } from './appBridge';

export const locale = i18n.global.locale.value;

const isM = window.sfe.isMobile;
const { isApp } = window.sfe;

// 跳转到登录
export const toLogin = (redirect) => {
    window.location.href = redirect ? `/${locale}/login/?redirect_url=${encodeURIComponent(redirect)}` : `/${locale}/login`;
};

// Redirect to SignUp
export const toSignUp = (redirect = window.location.href) => {
    window.location.href = redirect ? `/${locale}/register?redirect_url=${encodeURIComponent(redirect)}` : `/${locale}/register`;
};

// 跳转到kyc页面
export const toKyc = () => {
    window.location.href = '/user/accounts/auth';
};

/**
 * 跳转到充值页面
 *
 * @param {string} coin 币种
 * @param {boolean} newTab 是否新tab
 */
export const toRecharge = (coin = 'BTC', newTab) => {
    if (isApp) {
        jumpRecharge({ path: 'finance-invest-home', coin });
        return;
    }

    if (newTab) {
        window.open('/user/assets/home', '_blank');
    } else {
        window.location.href = '/user/assets/home';
    }
};

// 获取交易页面路径
export const getSpotTradePath = (token, base) => `/${locale}/trade/spot/${token}/${base}`;
// 获取投票上币-投票记录-页面路径
export const getVoteRecodPath = () => `/${locale}/trade/spot/vote-${isM ? 'm-' : ''}record/`;
// 获取投票上币-投票首页-页面路径
export const getVoteHomePath = () => `/${locale}/trade/spot/vote-${isM ? 'm-' : ''}home/`;
// 获取投票上币-详情页面-页面路径
export const getVoteDetailPath = (id) => `/${locale}/trade/spot/vote-${isM ? 'm-' : ''}detail/${id || ''}`;
// 获取投票上币-票据分配-页面路径
export const getVoteInstructionsPath = (id) => `/${locale}/trade/spot/vote-${isM ? 'm-' : ''}instructions/${id || ''}`;
// 获取投票上币-票据分配-页面路径
export const getVoteUserPath = (query) => `/${locale}/trade/spot/vote-${isM ? 'm-' : ''}user/${query ? `?${query}` : ''}`;

// 判断是否拥有Bybit账户，没有则跳转到Bybit注册页面
export const noBybitToRegister = (source) => {
    // 是否有Bybit账户
    const hasBybit = window?.sensors?.getPresetProperties?.()?.identities?.$identity_login_id;

    if (!isApp && !hasBybit) {
        const link = `/register?source=${source}`;
        window.location.href = link;
        return true;
    }
    return false;
};
